/**
 * The gong of the backup timer of the jury (#600): at Start and at 0:00. It
 * is a tone of the Web Audio API, so no audio file is necessary. A browser
 * starts audio only after a tap: `unlockRingSounds()` runs on each click on
 * the bout page while the Sarama card shows. Each call is safe: with no audio
 * the timer still works.
 */

let ctx: AudioContext | null = null;

/** Make the audio context in a click of the user, so the later gong can sound. */
export function unlockRingSounds(): void {
  try {
    if (!ctx) {
      const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Ctor) return;
      ctx = new Ctor();
    }
    // iOS reports 'interrupted' after a call or an alarm: resume each state that is not running.
    if (ctx.state !== 'running') ctx.resume().catch(() => { /* no audio: the timer still works */ });
  } catch {
    ctx = null;   // no audio: the timer still works
  }
}

/** One tone: a frequency that fades out over `seconds`. */
function tone(frequency: number, seconds: number, at = 0, volume = 0.6): void {
  if (!ctx) return;
  try {
    const start = ctx.currentTime + at;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(volume, start);
    gain.gain.exponentialRampToValueAtTime(0.001, start + seconds);
    osc.connect(gain).connect(ctx.destination);
    osc.start(start);
    osc.stop(start + seconds);
  } catch {
    // A failed tone is no failure of the timer.
  }
}

/** The gong: two low tones with a long fade. */
export function playGong(): void {
  tone(196, 2.5);
  tone(392, 1.8, 0, 0.25);
}
